import { render, staticRenderFns } from "./OpenProject.vue?vue&type=template&id=7881c589&scoped=true"
import script from "./OpenProject.vue?vue&type=script&lang=js"
export * from "./OpenProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7881c589",
  null
  
)

export default component.exports